export default "__VITE_ASSET__CrmiTjHQ__"